import { validateAlphaNumericString, validateName } from '@om/validation';
import { validationIsEqual } from '../status';
import {
    AGENT_CODE_SET_VALUE,
    AGENT_NAME_SET_VALUE,
    SET_INTERMEDIARY_TYPE_VALUE,
    setAgentCodeValid,
    setIntermediaryTypeValid,
    setNameValid,
} from '../../../actions/biasharaFlexi/agentModal';

let prevValidationAction = null;

export const agentValidation = (store, next, action) => {
    const validationAction = (() => {
        let error;

        const validateNameWithExtraSpaces = (value) => {
            const formattedValue = value.replace(/\s{2,}/g, ' ');

            let customError = validateAlphaNumericString(formattedValue, {
                min: 2,
                max: 48,
                subject: 'Name',
            });

            return customError;
        };

        switch (action.type) {
            case AGENT_NAME_SET_VALUE:
                error = validateNameWithExtraSpaces(action.value);
                return setNameValid(error);

            case AGENT_CODE_SET_VALUE:
                error = validateAlphaNumericString(action.value, {
                    subject: 'Code',
                });
                return setAgentCodeValid(error);

            case SET_INTERMEDIARY_TYPE_VALUE:
                error = validateName(action.value, {
                    subject: 'Intermediary',
                });
                return setIntermediaryTypeValid(error);

            default:
                return null;
        }
    })();

    if (!validationAction || validationIsEqual(validationAction, prevValidationAction)) {
        return next(action);
    }

    store.dispatch(validationAction);
    prevValidationAction = validationAction;
    return next(action);
};
